import { styled, Paper, IconButton } from '@mui/material';

export const Wrapper = styled(Paper)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
  height: '100%',
  padding: '24px 0px 24px 24px',
}));

export const Toolbar = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  paddingRight: 24,
}));

export const CloseButton = styled(IconButton)(() => ({
  marginTop: -7,
}));

export const Form = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
  paddingRight: 24,
  marginBottom: 10,
}));

export const Footer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: 12,
  paddingRight: 24,
}));
